import React from "react";

export default function About() {
  return (
    <>
      <div class="container">
        <h2 class="text-center my-4">About Us</h2>
        <section class="page-section bg-light py-5" id="about">
          <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
              <div class="col-lg-8 text-center">
                <h2 class=" text-dark mt-0">Empowering Your Vision</h2>
                <hr class="divider divider-light my-4" />
                <p class="text-white-75 mb-4">
                  We are dedicated to delivering innovative and reliable
                  solutions to help you achieve your goals. With expertise in
                  modern technologies, we aim to empower businesses and
                  individuals by providing world-class services tailored to your
                  needs.
                </p>
                <a class="btn btn-light btn-xl" href="#services">
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
